import { Navigate, Outlet } from "react-router-dom";
import { useAuthStore } from "../stores/zustand";

const RequirePhysioAccess = () => {
  const { isAuthenticated, currentProduct } = useAuthStore();

  if (!isAuthenticated()) {
    return <Navigate to="/" replace />;
  }

  if (currentProduct !== "physio_therapist") {
    return <Navigate to="/home/calendar" replace />;
  }

  return <Outlet />;
};

export default RequirePhysioAccess;
